export const isValidPrecriberNumberFormat = (prescriberNumber?: string) =>
  !!prescriberNumber && !!prescriberNumber.match(/^[0-9]{6,7}$/)
